import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  handleClose?: () => void;
  handleConfirm: () => void;
  isOpen: boolean;
  title: string;
  description: string;
}

const PromptDialog: React.FC<Props> = ({
  handleClose,
  handleConfirm,
  isOpen,
  title,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {handleClose && (
          <Button onClick={handleClose}>{t("general.cancel")}</Button>
        )}
        <Button
          variant="contained"
          onClick={handleConfirm}
          color="primary"
          autoFocus
        >
          {t("general.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PromptDialog;
